type GridProps = {
  children: React.ReactNode
}

export const Grid = ({children}:GridProps) => 
<div className="grid">
  {children}
</div>

